import http from 'hub-http/clients/apiClient';
import { getFullUrl } from 'hubspot-url-utils';
export const activateCms = () => http.post(`${getFullUrl('app-api', {})}/partner-client-activation/v1/cms`);